export const ru = {
  showing_info:
    '{amount, plural, one {Показан #} other {Показано #}} из {totalAmount, plural, one {# товара} few {# товаров} other {# товаров}}',
}
